import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const Select = forwardRef((props, ref) => {
  const {
    className,
    background,
    borderRadius,
    borderColor,
    color,
    fontSize,
    border,
    error,
    fontFamily,
    options,
    ...otherProps
  } = props;
  return (
    <>
      <select
        ref={ref}
        {...otherProps}
        className={classNames(
          "p-1 outline-0 w-full h-12",
          className || "placeholder:text-neutral-80 ",
          background || "bg-transparent",
          borderRadius || "rounded-none",
          color || "text-neutral-80",
          fontSize || "text-base",
          borderColor || "border-main-blue",
          border || "border-b",
          fontFamily || "font-text"
        )}
      >
        {options &&
          options?.map((option, key) => {
            const { value, label, ...otherProps } = option;
            return (
              <option value={value} key={key} {...otherProps}>
                {label}
              </option>
            );
          })}
      </select>
      <span className="text-xxs text-red-500 font-text">{error}</span>
    </>
  );
});
Select.displayName = "Select";
Select.propTypes = {
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  borderColor: PropTypes.string,
  fontSize: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
  options: PropTypes.array,
};

export default Select;
